import { useState, Key, useEffect } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import useGlobalModel from '@/model/globalModel'
import { IVehicleDetail } from '@/views/base/customerFiles/vehicle/vehicleType'
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import { ISaleRoFields, IDetailList, ISaleSoDetailsSearch, ISaleSoDetails, ISaleRoSettleParams, ISettleDetails } from '../../saleRoTypes'
import { saleRoService } from '../../saleRoService'
import { IVRMshelfDetail } from '@/views/base/warehouse/warehouseTypes'
import { ISearchPage } from '@/types/ScmTypes'
import { formatNum, IsUseDefaultBentity, transPgToPagination } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import { DictCodeEnmu, sourceAppOrBranch } from '@/types/VrmSaDictEnums'
import { convertRes2Blob } from '@/utils/exportFile'
import { IStockStatisticDetail } from '@/views/stock/statistic/stockStatisticService'
import { useLockFn } from 'ahooks'
import { message } from 'antd'

export type ISaleRoDescType = {
    numAll: number
    itemNumAll: number
    totalAll: number
    discountAll: number
    receivableAll: number
    [key: string]: any
}
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends ISaleSoDetails {
    num: number
    // price?: number,
    // amount?: number,
    saleNum?: number
    salePrice?: number
    saleTotal?: number
    decreaseAmount?: number
}
export const useSaleRoDetailModel = createModel(function () {
    const { user, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName } = shopAndOrg
    const [logisticsDraer, setLogisticsDraer] = useState<boolean>(false) //物流登记弹框
    const [settleVisible, setSettleVisible] = useState<boolean>(false) //结算弹框

    const [changeSaleDrawer, serChangeSaleDrawer] = useState<boolean>(false) //转销售单弹框
    const [wsConfirmModal, setWsConfirmModal] = useState<boolean>(false) //库房确认弹框
    const [registerModal, setRegisterModal] = useState<boolean>(false) //入库登记弹框
    const [discountModal, setDiscountModal] = useState<boolean>(false) //折扣弹框

    const [addModalVisible, setAddModalVisible] = useState<boolean>(false) //新增商品弹框
    const [vehicleEditAll, setVehicleEditAll] = useState<IVehicleDetail[]>([]) //实时切换车辆 编辑
    const [vehicleAddAll, setVehicleAddAll] = useState<IVehicleDetail[]>([]) //实时切换车辆 新增
    const initDesc = {
        numAll: 0, //数量
        itemNumAll: 0, //项数
        totalAll: 0, //总计
        discountAll: 0, //折扣,
        receivableAll: 0, //应收
    }
    const initForm = {
        shopId,
        shopName,
        favorableAmount: 0,
        // bentityCode: IsUseDefaultBentity(shopId) ? DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE : '',
        // bentityName: IsUseDefaultBentity(shopId) ? beShopDs.find((item) => item.value === DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE)?.label : '',
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: ISaleSoDetailsSearch = {}
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<ISaleRoFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([])
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([])
    const [addDesc, setAddDesc] = useState<ISaleRoDescType>(initDesc)

    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<ISaleRoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISaleRoDescType>(initDesc)
    //查看结算详情
    const [lookSettleDetails, setLookSettleDetails] = useState<ISettleDetails[]>([])
    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([])
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([])
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([])
    const [detailEditForm, setDetailEditForm] = useState<ISaleRoFields>({})
    const [editDesc, setEditDesc] = useState<ISaleRoDescType>(initDesc)
    //编辑结算详情
    const [editSettleDetails, setEditSettleDetails] = useState<ISettleDetails[]>([])
    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<ISaleSoDetailsSearch>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([])
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)

    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IVRMshelfDetail[]>([])
    const [saveLoading, setSaveLoading] = useState<boolean>(false) //  保存按钮
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        // let newDesc: ISaleRoDescType = initDesc;
        // detailDataSource && detailDataSource.forEach(item => {
        //     newDesc.numAll += Number(item.num);
        //     newDesc.totalAll += Number(item.amount);
        // });
        // newDesc.itemNumAll = detailDataSource && detailDataSource.length
        // setEditDesc(newDesc);
    }, [detailDataSource, detailEditForm])

    useEffect(() => {
        // let newDesc: ISaleRoDescType = initDesc;
        // detailAddList && detailAddList.forEach(item => {
        //     newDesc.numAll += Number(item.num);
        //     newDesc.totalAll += Number(item.amount);
        // });
        // newDesc.itemNumAll = detailAddList && detailAddList.length
        // setAddDesc(newDesc);
    }, [detailAddList, detailAddForm])

    useEffect(() => {
        // let newDesc: ISaleRoDescType = initDesc;
        // detailLookList && detailLookList.forEach(item => {
        //     newDesc.numAll += Number(item.num);
        //     newDesc.totalAll += Number(item.amount);
        // });
        // newDesc.itemNumAll = detailLookList && detailLookList.length
        // setLookDesc(newDesc);
    }, [detailLookList, detailLookForm])

    //新增表单缓存
    const updateAddFormVal = (val: ISaleRoFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: ISaleRoFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await saleRoService.one(id)
        const { details, settleDetails, ...from } = retData
        const newDetails = details?.map((item) => {
            return {
                ...item,
                notAmount: +formatNum(Number(item.num) * Number(item.price)),
                detailsId: item.id,
                discountAmount: +formatNum(item.discountAmount) ?? +formatNum(Number(item.num) * Number(item.price) * (Number(item.discountRate) / 100)) ?? 0,
            }
        })
        let newDesc: ISaleRoDescType = initDesc
        details?.forEach((item) => {
            newDesc.numAll += Number(item.num)
            newDesc.totalAll += Number(item.amount)
            newDesc.itemNumAll = details && details.length
        })
        setAddDesc(newDesc)
        if (retData) {
            let fileList: any = [],
                cashFileList: any = []
            const { md5, fileName } = from

            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            if (settleDetails && settleDetails.length > 0) {
                const { cashAttach, cashAttachFileName } = settleDetails[0]
                if (cashAttach && cashAttachFileName) {
                    cashFileList = [
                        {
                            uid: cashAttach,
                            status: 'done',
                            name: cashAttachFileName,
                            response: {
                                retData: cashAttach,
                            },
                        },
                    ]
                }
            }
            from.fileList = fileList
            from.cashFileList = cashFileList
            if (pattern === 'edit') {
                setDetailDataSource((newDetails as IDetailList[]) ?? [])
                setDetailEditForm({
                    ...from,
                    salesTypeCode: from.salesTypeCode === '' || from.salesTypeCode === null ? DictCodeEnmu.SALES_TYPE_NORMAL : from.salesTypeCode,
                })
                setTopButsControl(false)
                setEditSettleDetails((settleDetails as ISettleDetails[]) ?? [])
            } else if (pattern === 'look') {
                setDetailLookForm({
                    ...from,
                    cashName: settleDetails?.[0]?.payMethodName,
                    salesTypeCode: from.salesTypeCode === '' || from.salesTypeCode === null ? DictCodeEnmu.SALES_TYPE_NORMAL : from.salesTypeCode,
                })
                setDetailLookList((newDetails as IDetailList[]) ?? [])
                setLookSettleDetails((settleDetails as ISettleDetails[]) ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async (params: ISaleSoDetailsSearch) => {
        setSearchWorkData({ ...params })
        workloadData(initPgCfg, { ...params })
    }
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: ISaleSoDetailsSearch = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            // ...shopAndOrg...shopAndOrg,
            ...sourceAppOrBranch,
            shopName: detailEditForm?.shopName ?? detailAddForm?.shopName,
            shopId: detailEditForm?.shopId ?? detailAddForm?.shopId,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleRoService.saleDetails(searchParams)
        const { records, ...pg } = retData
        const newRecords = records.map((item) => {
            let { num, price, discountRate, amount } = item as { num: number; price: number; discountRate: number; amount: number }
            return {
                ...item,
                saleNum: num,
                salePrice: price,
                saleTotal: amount,
                num: 1,
                price: price,
                amount: +formatNum((num * price * discountRate) / 100),
                decreaseAmount:
                    +formatNum((num * price * discountRate) / 100) > Number(item.leftDecreaseAmount)
                        ? item.leftDecreaseAmount
                        : +formatNum((num * price * discountRate) / 100),
            }
        })
        setWorkPgCfg(transPgToPagination(pg))
        setWorkDataSource(newRecords)
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailModel[], detailList: IDetailList[]) => {
        const repetition: string[] = []
        const newDetailData: IDetailList[] = []
        console.log(modelList)
        modelList.forEach((Item) => {
            let isSelect = detailList && detailList.find((item) => item.detailId === Item.id)
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    detailId: Item.id,
                    id: '',
                    amount: +formatNum(Number(Item.amount) - Number(Item.decreaseAmount)),
                    discountAmount: +formatNum(Number(Item.num) * Number(Item.price) * (Number(Item.discountRate) / 100)),
                    purchaseId: Item.purchaseId,
                    salesTypeCode: Item.salesTypeCode,
                    salesTypeName: Item.salesTypeName,
                    rdecreaseAmount: +formatNum(Item.decreaseAmount) ?? 0,
                })
            } else {
                repetition.push(Item.materialName as string)
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === 'add') {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList)
            setDetailAddList([...detailAddList, ...newDetailData])
            setDetailAddForm({
                ...detailAddForm,
                salesTypeCode: newDetailData[0]?.salesTypeCode ?? DictCodeEnmu.SALES_TYPE_NORMAL,
                salesTypeName: newDetailData[0].salesTypeName ?? '正常销售',
            })
            repetition.length !== 0 && globalPrompt('message', { text: `物料名称：${repetition.join(',')}，采购单号相同，重复的将不在添加。`, type: 'warning' })
        } else if (mode === 'edit') {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            setDetailEditForm({
                ...detailEditForm,
                salesTypeCode: newDetailData[0]?.salesTypeCode ?? DictCodeEnmu.SALES_TYPE_NORMAL,
                salesTypeName: newDetailData[0].salesTypeName ?? '正常销售',
            })
            repetition.length !== 0 && globalPrompt('message', { text: `物料名称：${repetition.join(',')}，采购单号相同，重复的将不在添加。`, type: 'warning' })
        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        if (mode === 'add') {
            // const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.materialCode))
            const filterDetailList = Material
                ? detailAddList.filter((el) => !!!(Material.detailId === el.detailId))
                : detailAddList.filter((el) => !!!detaiAddDataRowKeys.find((ele) => ele === el.detailId))
            setDetailAddList(filterDetailList)
            globalPrompt('message', { text: `删除成功`, type: 'success' })
            setDetaiAddDataRowKeys([])
            setDetaiAddDataRow([])
        } else if (mode === 'edit') {
            const backendDetailList: any = Material
                ? Material.id
                    ? [{ id: Material.id }]
                    : []
                : detailDataRow.reduce((all: object[], next) => {
                    //前端页面维护的需要删除的id
                    if (next.id) {
                        all.push({ id: next.id })
                    }
                    return all
                }, [])

            //删除详情列表调用的方法
            const deleteData = () => {
                // const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.detailId))
                const filterDetailList = Material
                    ? detailDataSource.filter((el) => !!!(Material.detailId === el.detailId))
                    : detailDataSource.filter((el) => !!!detailDataRowKeys.find((ele) => ele === el.detailId))
                setDetailDataSource(filterDetailList)
                globalPrompt('message', { text: `删除成功`, type: 'success' })
                setDetailDataRowKeys([])
                setDetailDataRow([])
            }

            if (backendDetailList.length > 0) {
                await saleRoService.materialDelete({ ids: backendDetailList, returnCode: detailEditForm.returnCode as string }).then((res) => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        globalPrompt('message', { text: `删除失败`, type: 'success' })
                    }
                })
            } else {
                deleteData()
            }
        }
    }
    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === 'edit' ? detailDataSource : detailAddList
        let { totalAll } = mode === 'edit' ? editDesc : addDesc
        totalAll = +formatNum(totalAll) //应收
        let goodsTotal: number = 0
        goods.forEach((item) => {
            let { amount } = item as { amount: number }
            goodsTotal += amount
        })
        if (+formatNum(goodsTotal) !== totalAll) {
            message.warning(`详情销退总金额金额${+formatNum(goodsTotal)}与表单销退总金额金额不符`)
            return false
        }
        return true
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: ISaleRoFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList.map((item) => {
                    let { discountAmount, ...params } = item
                    return params
                }),
                createUser: user.username,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await saleRoService.insert(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: ISaleRoFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource.map((item) => {
                    let { discountAmount, ...params } = item
                    return params
                }),
                updateUser: user.username,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await saleRoService.update(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type?: string) => {
        setDetailAddList([])
        setDetailAddForm(initForm)
    }
    const resetEditCatch = async (type?: string) => {
        setDetailEditForm({})
        setDetailDataSource([])
    }
    const downloadTpl = async () => {
        let result = await saleRoService.downloadTpl()
        convertRes2Blob(result)
    }
    const warehousing = async () => {
        let { id, returnCode } = detailEditForm
        let paramas = {
            id,
            returnCode,
            storekeeper: user.username,
        }
        let { retData } = await saleRoService.warehousing(paramas)
        return retData
    }
    const onSettle = async (params: ISaleRoSettleParams) => {
        let { retData } = await saleRoService.settle(params)
        return retData
        // if (retData) {
        //     await setSettleVisible(true)
        //     await getDetailEditOne(detailEditForm.purchaseCode as string, "edit")
        //     await globalPrompt("message", { text: `结算成功`, type: "success" });
        // }
    }
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [consumeHistoryVisible, setConsumeHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [consumeHistoryModel, setConsumeHistoryModel] = useState<{ customerName: string }>({ customerName: '' }) //消费记录参数
    const [repairHistoryModel, setRepairHistoryModel] = useState<boolean>(false) //维修历史
    return {
        settleVisible,
        changeSaleDrawer,
        wsConfirmModal,
        registerModal,
        logisticsDraer,
        discountModal,
        setSettleVisible,
        serChangeSaleDrawer,
        setWsConfirmModal,
        setRegisterModal,
        setLogisticsDraer,
        setDiscountModal,
        vehicleEditAll,
        setVehicleEditAll,
        vehicleAddAll,
        setVehicleAddAll,
        // data
        addModalVisible,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        addDesc,
        detailLookForm,
        detailLookList,
        lookDesc,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        editDesc,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        shelfAllList,
        detaiAddDataRowKeys,
        // model
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setAddDesc,
        setDetailLookForm,
        setDetailLookList,
        setLookDesc,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setEditDesc,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setShelfAllList,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        warehousing,
        onSettle,
        initForm,
        topButsControl,
        setTopButsControl,
        historyVisible,
        setHistoryVisible,
        historyRow,
        setHistoryRow,
        lookSettleDetails,
        setLookSettleDetails,
        editSettleDetails,
        setEditSettleDetails,
        consumeHistoryModel,
        setConsumeHistoryModel,
        consumeHistoryVisible,
        setConsumeHistoryVisible,
        repairHistoryModel,
        setRepairHistoryModel,
        formComputeRule,
        saveLoading,
        setSaveLoading,
    }
})
